<template>
    <div  id="app">
      <!--SideNav-->
      <side-nav class="white-skin" :open="toggle" />
      <!--/SideNav-->

      <div class="flexible-content">
        <!--Navbar-->
        <navbar :page="activePage" />
        <!--/Navbar-->
          <div class="mainContent">
            <router-view></router-view>
          </div>
        <!--/MainContent-->

        <!--Footer-->
        <div class="white-skin">
          <copyrights />
        </div>
        <!--/Footer-->
      </div>
    </div>
</template>

<script>
/* eslint-disable */
import SideNav from "./SideNav";
import Navbar from "./Navbar";
import Copyrights from "./Footer";
import Axios from "axios";
import Servers from "../../server.js";
import qs from "qs"
import { mapGetters, mapActions } from "vuex";

import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbInput,
  mdbBtn,
  mdbIcon,
  mdbView,
  mdbMask,
} from "mdbvue";

export default {
  name: "Principal",
  components: {
    SideNav,
    Navbar,
    Copyrights,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbInput,
    mdbBtn,
    mdbIcon,
    mdbView,
    mdbMask,
  },
  data() {
    return {
      activePage: "Dashboardv2",
      toggle: false,
      email: '',
      password: '',
      resetRoute: "/resetPassword",
      showErrorLogin: false,

    };
  },
  computed:{
     ...mapGetters({
      "myfrac":"getWhoAmi",
      "isLogin":"getAuthenticated"
    }),
  },
  mounted() {
    this.$on("toggle", function(value){
      this.toggle = value
    });
    this.activePage = this.$route.name;
    
        // if (localStorage.getItem("access_token")==null){
        //   localStorage.clear();
        //   //window.location.href="/"; DESCOMENTAR
        //   //window.location.href= Servers.serverWeb;
    
       
        //   //localStorage.clear();
        //   this.$router.push("/")
        //   //window.location.href="/"; DESCOMENTAR
        //   //window.location.href= Servers.serverWeb;
        //   //window.location.reload(); DESCOMENTAR
           
        // }else{
        //   this.$router.push("/home")
        //   //if(this.$route.name==null)
        //       //window.location.href= Servers.serverWeb;
        //      //window.location.href="/home"; DESCOMENTAR 
        //   //this.checkMe();
          
        // }
            
  },
  updated() {
    this.activePage = this.$route.name;
  },
  methods: {
    //   checkMe() {
    //   let aux = this;
    //   Axios.get(Servers.serverApi + "api/users/me", {
    //     headers: {
    //       Authorization: "Bearer " + localStorage.getItem("access_token")
    //     }
    //   }).then(
    //     function(response) {
    //       localStorage.setItem('me',JSON.stringify(response.data));
    //       aux.$store.commit('setMe',response.data);
    //     },
    //   ).catch(function(error){
    //     console.log(error.response.data)

    //   });
    // },

    
  }
};
</script>

<style scoped>

html {
  font-size: 16px;
  width: 100%;
}

body {
  font-weight: 300;
  background-color: #eee;
}

main {
  min-height: 90vh;
}

.side-nav .logo-sn {
  padding-bottom: 1rem;
  padding-top: 1rem;
  border-bottom: 1px solid rgba(153, 153, 153, 0.3);
}

.navbar .btn,
.navbar .nav-item,
.navbar .nav-link {
  padding: 0;
}

.select-wrapper input.select-dropdown {
  font-size: 14px;
}

.form-control {
  font-size: 14px;
}

.cascading-admin-card {
  margin-top: 20px;
}
.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
}
.cascading-admin-card .admin-up .fas,
.cascading-admin-card .admin-up .far,
.cascading-admin-card .admin-up .fab {
  padding: 1.7rem;
  font-size: 2rem;
  color: #fff;
  text-align: left;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}
.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}
.cascading-admin-card .admin-up .data p {
  color: #999999;
  font-size: 12px;
}

.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}
.classic-admin-card .card-body p {
  font-size: 13px;
  opacity: 0.7;
  margin-bottom: 0;
}
.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
.classic-admin-card .card-body .float-right .fas,
.classic-admin-card .card-body .float-right .far,
.classic-admin-card .card-body .float-right .fab {
  font-size: 3rem;
  opacity: 0.5;
}

.table-ui {
  border: 1px solid #e0e0e9;
}

.fullscreen {
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 100000;
  min-height: 100vh;
}

.fullscreen-view {
  height: 100vh;
}

.form-control {
  height: calc(2rem + 1px);
  padding: 0.375rem 0.75rem;
}

.list-group .ml-auto {
  float: right;
  flex: none !important;
}

.datepicker-overlay {
  z-index: 9999 !important;
}

.mainContent {
  margin: 7% 5% 5% 5%;
  padding-left: 240px;
  min-height: calc(80vh - 86px);
}


@media only screen and (max-width: 1440px) {
  .side-nav.fixed {
    transform: translateX(0) !important;
  }
  .mainContent {
    padding-left: 0px;
  }
}

@media screen and (max-width:320){
  
  .bg-login{
    width: 10rem
  }
  
}

.navbar-brand {
  cursor: pointer;
}


</style>